export const YUSA_OVERNIGHT_CAMP_GET_ENROLLMENT_AND_OCCUPANCY_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_GET_ENROLLMENT_AND_OCCUPANCY_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_GET_ENROLLMENT_AND_OCCUPANCY_FAILURE =
  'YUSA_OVERNIGHT_CAMP_GET_ENROLLMENT_AND_OCCUPANCY_FAILURE';

export const YUSA_OVERNIGHT_CAMP_POST_ENROLLMENT_AND_OCCUPANCY_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_POST_ENROLLMENT_AND_OCCUPANCY_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_POST_ENROLLMENT_AND_OCCUPANCY_FAILURE =
  'YUSA_OVERNIGHT_CAMP_POST_ENROLLMENT_AND_OCCUPANCY_FAILURE';

export const YUSA_OVERNIGHT_CAMP_GET_PARTICIPANTS_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_GET_PARTICIPANTS_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_GET_PARTICIPANTS_FAILURE =
  'YUSA_OVERNIGHT_CAMP_GET_PARTICIPANTS_FAILURE';

export const YUSA_OVERNIGHT_CAMP_POST_PARTICIPANTS_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_POST_PARTICIPANTS_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_POST_PARTICIPANTS_FAILURE =
  'YUSA_OVERNIGHT_CAMP_POST_PARTICIPANTS_FAILURE';
